<template>
  <v-card v-if="distribution" class="current-distribution-container px-10 py-6">
    <div class="header d-flex flex-row justify-space-between align-start">
      <span class="title">Distribuição atual dos cupons de desconto</span>
      <mf-button text-transform="none" outlined color="marca-0-l20" label="Ajustar limite" icon="tune" icon-position="left" @click="redirectAdjustLimits" />
    </div>
    <div class="multiple-bars mt-5">
      <mf-multiple-bars :values="barsValues" :available-label="availableLabel" fix-labels show-available-percentage :total="total" />
    </div>
    <div class="history-link d-flex justify-end mt-10">
      <router-link class="redirect-link" target="_blank" :to="`/campanhas/cupom-desconto/historico-utilizacao/${this.benefitId}`"
        >Ver histórico de utilização</router-link
      >
    </div>
  </v-card>
</template>

<script>
import { localeString } from '@/config/helpers.js'
import { couponDiscount } from '../../../mixins/coupon-discount'

export default {
  name: 'CouponCurrentDistribution',
  components: {},
  mixins: [couponDiscount],
  props: {},
  data: () => ({
    benefitId: null,
    distribution: null,
  }),
  computed: {
    availableLabel() {
      if (this.distribution.availableCoupons !== 1) {
        return 'Cupons disponíveis'
      } else {
        return 'Cupom disponível'
      }
    },
    barsValues() {
      return [
        {
          label: `Cupons na carteira (${localeString((this.distribution.redeemedCoupons * 100) / this.total, 0)}%)`,
          color: '#F36600',
          number: this.distribution.redeemedCoupons,
        },
        {
          label: `Cupons ativos (${localeString((this.distribution.activatedCoupons * 100) / this.total, 0)}%)`,
          color: '#00366D',
          number: this.distribution.activatedCoupons,
        },
        {
          label: `Cupons consumidos (${localeString((this.distribution.consumedCoupons * 100) / this.total, 0)}%)`,
          color: '#0079F2',
          number: this.distribution.consumedCoupons,
        },
      ]
    },
    total() {
      if (!this.distribution) return 0

      return (
        this.distribution.activatedCoupons +
        this.distribution.consumedCoupons +
        this.distribution.redeemedCoupons +
        Math.max(0, this.distribution.availableCoupons)
      )
    },
  },
  watch: {},
  mounted() {
    this.benefitId = this.benefit._id
    this.distribution = this.benefitDistribution
  },
  methods: {
    redirectAdjustLimits() {
      this.$router.push(`/campanhas/cupom-desconto/${this.benefitId}`).catch(() => {})
    },
    redirectUsageHistory() {
      this.$router.push(`/campanhas/cupom-desconto/historico-utilizacao/${this.benefitId}`).catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
.current-distribution-container {
  .header {
    .title {
      font-size: 22px;
      font-weight: 700;
      line-height: 120%; /* 26.4px */
      letter-spacing: 0.22px;
      color: $cinza-d10;
      font-family: Lato;
    }
  }
  .history-link {
    .redirect-link {
      color: $marca-0-l40 !important;
      font-size: 14px;
      font-weight: 400;
      line-height: 18px; /* 128.571% */
      letter-spacing: 0.14px;
      text-decoration: none !important;
    }
  }
}
</style>
